import React from "react";

import { Box } from "./styles";

function noImage() {
  return (
    <div className="no-images flex w100">
      {/* <p>Images Forthcoming</p> */}
      <Box />
    </div>
  );
}

export default noImage;



// WEBPACK FOOTER //
// ./src/components/ProgramsDetail/NoImages.jsx